export const MAX_GUESSES = 4;
